import moment from 'moment-timezone';

export function formatTimeIST(dateString?: string): string {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'N/A';

  // Format time in IST with hour and minute
  const formatter = new Intl.DateTimeFormat('en-IN', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });

  const formatted = formatter.format(date);
  return formatted.replace(/\s?(am|pm)$/i, (match) => match.toUpperCase());
}

export function formatDate(value: any): string {
  try {
    const date = new Date(value);
    if (!isNaN(date.getTime())) {
      return `${String(date.getDate()).padStart(2, '0')}/${String(
        date.getMonth() + 1
      ).padStart(2, '0')}/${date.getFullYear()}`;
    }

    const [year, month, day] = String(value).split(/[-/]/);
    return day && month && year ? `${day}/${month}/${year}` : 'N/A';
  } catch {
    return 'N/A';
  }
}

export const convertToISTDateTime = (date: string, time?: string): string => {
  if (!date) return '';

  const [day, month, year] = date.split('/');
  const formattedTime = time && time !== 'N/A' ? time : '00:00 AM';

  const fullDateTime = `${day}/${month}/${year} ${formattedTime}`;

  return moment
    .tz(fullDateTime, 'DD/MM/YYYY hh:mm A', 'Asia/Kolkata')
    .format('YYYY-MM-DDTHH:mm:ssZ');
};
